var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "Follow.UserUnfollow",
    "options": {
        "objc_class_prefix": "FollowUserUnfollow",
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [
        {
            "name": "Request",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "fuid",
                    "id": 1
                }
            ]
        }
    ]
}).build();
export default _root;


// WEBPACK FOOTER //
// ./js/pb_map/protos_file/unfollow.pb.js